import React from "react";
import backPlay from "../../icons/Back.svg";
import forwardPlay from "../../icons/Forward.svg";
import pan from "../../icons/Pan.svg";
import pause from "../../icons/Pause.svg";
import play from "../../icons/Play.svg";
import playBlack from "../../icons/PlayBlack.svg";
import zoomIn from "../../icons/Zoom In.svg";
import zoomOut from "../../icons/Zoom Out.svg";
import backChevron from "../../icons/back-chevron.svg";
import calendar from "../../icons/calendar-icon.svg";
import check from "../../icons/check.svg";
import down from "../../icons/down-chevron.svg";
import downTriangle from "../../icons/down-triangle.svg";
import ellipses from "../../icons/ellipses-icon.svg";
import filter from "../../icons/filter.svg";
import forward from "../../icons/forward-chevron.svg";
import leftTriangle from "../../icons/left-triangle.svg";
import loadingButton from "../../icons/loading-button.svg";
import loading from "../../icons/loading-icon.svg";
import loadingSpinner from "../../icons/loading-spinner-red.svg";
import loadingSpinnerWhite from "../../icons/loading-spinner-white.svg";
import modalClose from "../../icons/modal-close-icon.svg";
import rightTriangls from "../../icons/right-triangle.svg";
import search from "../../icons/search.svg";
import upChevron from "../../icons/up-chevron.svg";
import upTriangle from "../../icons/up-triangle.svg";
import uploadLarge from "../../icons/upload-icon-large.svg";
import uploadWhite from "../../icons/upload-icon-white.svg";
import upload from "../../icons/upload-icon.svg";
import warning from "../../icons/warning.svg";
import close from "../../icons/x.png";

const settings = {
  backPlay,
  forwardPlay,
  pan,
  pause,
  play,
  playBlack,
  zoomIn,
  zoomOut,
  backChevron,
  calendar,
  check,
  down,
  downTriangle,
  ellipses,
  filter,
  forward,
  leftTriangle,
  loadingButton,
  loading,
  loadingSpinner,
  loadingSpinnerWhite,
  modalClose,
  rightTriangls,
  search,
  upChevron,
  upTriangle,
  uploadLarge,
  uploadWhite,
  upload,
  warning,
  close,
};
export const Icon = props => {
  const { iconName, name, disabled = false, ...otherProps } = props;

  if (!settings[iconName]) {
    return null;
  }
  return (
    <img
      src={settings[iconName]}
      alt={name || iconName}
      style={{ padding: 3, cursor: disabled ? "auto" : "pointer" }}
      {...otherProps}
    />
  );
};
